import { RootState } from "redux/rootReducer";

export const selectIsLoadingFullStress = (state: RootState) =>
  state.fullStressCheckTypeInfo.loading;
export const selectFullStressErrorMessage = (state: RootState) =>
  state.fullStressCheckTypeInfo.error;
export const fullStressCheckTypeInfoDataResponse = (state: RootState) =>
  state.fullStressCheckTypeInfo.fullStressCheckTypeInfoResponse;
